/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Nav_Stock_In_NotesInputs */

const vi_pl_nav_stock_in_notes = /** @type {(inputs: Pl_Nav_Stock_In_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách PNK`)
};

/**

* @param {Pl_Nav_Stock_In_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_nav_stock_in_notes = /** @type {((inputs?: Pl_Nav_Stock_In_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Nav_Stock_In_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_nav_stock_in_notes(inputs)
});